/**
 * Zod schemas for validation (future use)
 */

// Placeholder for Zod schemas when needed
export const schemas = {};
